import { render } from "./AdminSidebar.vue?vue&type=template&id=6dca56fe"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"

import "./AdminSidebar.vue?vue&type=style&index=0&id=6dca56fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__